// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"399475db","455":"4bc6f9e4","488":"7b406be5"}[chunkId] + ".chunk.js";
};